
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MenuItemProps } from ".";
import { loading, find } from "store/menu";

interface ApiMenuFindByIdInputProps {
    id: number;
}

type ApiMenuFindOutputProps = OutputBaseProps<{ item: MenuItemProps; }, ApiMenuFindByIdInputProps>

export const apiMenuFindById = async (data: ApiMenuFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMenuFindOutputProps>(`/api/menu/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};